import { useEffect, useRef } from "react"

export default function useAutoFocusInput() {
  const inputRef = useRef()

  useEffect(() => {
    if (inputRef.current) {
      setTimeout(() => {
        inputRef.current.focus()
        inputRef.current.select()
      }, 0)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { inputRef }
}
